module.exports = __webpack_public_path__ + "img/mature-businesses.be90f967.svg";